<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-1 mr-2"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editTripLog"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  methods: {
    editTripLog() {
      this.params.context.parentComponent.editTripLog({ ...this.params.data });
    },
  },
};
</script>

<style></style>
